import React from 'react';
import { View, Text, Pressable, StyleSheet, ScrollView } from 'react-native';
import OPPureComponent from './op_pure_component';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

class MenuItem extends OPPureComponent {
  handlePress = () => {
    const { index, onPress } = this.props;
    onPress && onPress(index);
  };

  render() {
    const { label, selected, extraStyle } = this.props;

    return (
      <Pressable
        style={[styles.item, extraStyle, selected ? styles.itemSelected : null]}
        onPress={this.handlePress}
      >
        <Text style={[styles.itemText, selected ? styles.itemTextSelected : null]}>{label}</Text>
      </Pressable>
    );
  }
}

export default class Menu extends OPPureComponent {
  constructor(props) {
    super(props);
  }

  renderItem = ({ index, label }) => {
    const { onPress, selectedIndex, items } = this.props;

    return (
      <MenuItem
        key={`${index}`}
        index={index}
        label={label}
        selected={selectedIndex === index}
        onPress={onPress}
        extraStyle={items.length < 3 ? styles.itemWide : null}
      />
    );
  };

  render() {
    const { items, scrollable } = this.props;
    if (scrollable) {
      return (
        <ScrollView
          contentContainerStyle={styles.horizontalScrollViewContent}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          horizontal={true}
        >
          {items.map(this.renderItem)}
        </ScrollView>
      );
    } else {
      return <View style={styles.container}>{items.map(this.renderItem)}</View>;
    }
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  item: {
    flexGrow: __WEB__ ? 0 : 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 15,
    borderBottomColor: '#e4e4e4',
    borderBottomWidth: 2,
  },
  itemWide: {
    paddingHorizontal: 45,
  },
  itemSelected: {
    borderBottomColor: COLOR.emphasis,
  },
  itemText: {
    ...FONT.regular,
    fontSize: 16,
    color: '#1d1d26',
  },
  itemTextSelected: {
    ...FONT.semibold,
  },
});
